let context = {
    map:null,
    //获取服务端根路径
    serverRoot:function serverRoot() {
        const {REACT_APP_SERVER_ROOT, PUBLIC_URL} = process.env;
        return REACT_APP_SERVER_ROOT || (PUBLIC_URL === "" ? "/" : PUBLIC_URL.slice(0, PUBLIC_URL.lastIndexOf("/") + 1));
    },
    homePage:function serverRoot() {
        const { PUBLIC_URL} = process.env;
        console.log(PUBLIC_URL);
        return (PUBLIC_URL ? PUBLIC_URL : PUBLIC_URL.slice(0, PUBLIC_URL.lastIndexOf("/") + 1));
    },
    appConfig:{},
    mapManger:null,
    toolkitManager:[],
}
window.context = context;
export default context;